export default function() {
    var table = $('#users-table').DataTable({
        processing: true,
        serverSide: true,
        responsive: true,
        ajax: "/datatables/users",
        columns: [
            {name: 'action', data: 'action'},
            {data: 'name', name: 'name', width: '50%'},
            {data: 'email', name: 'email', width: '50%'},
        ],
        language: {
            "sLengthMenu": "_MENU_ Operatori per pagina",
            "sZeroRecords": "Nessun Operatore",
            "sInfo": "Mostra da _START_ a _END_ di _TOTAL_ Operatori",
            "sInfoEmpty": "0 di 0 su 0 Operatori",
            "sInfoFiltered": "(Filtrati _MAX_ Operatori)",
            "sInfoPostFix": "",
            "sSearch": "Cerca",
            "oPaginate": {
                "sFirst":    "Inizio",
                "sPrevious": "Indietro",
                "sNext":     "Avanti",
                "sLast":     "Fine"
            }
        },
    });

    $(document).on('click', '#create-user .btn-backend', function(){
        $('.form-loader').removeClass('d-none');
        $('#create-user').addClass('d-none');
        $.ajax({
            'url': '/ajax/create-user',
            'method': 'POST',
            'data': $('#create-user').serialize(),
            success: function(response){
                if(response.success){
                    $('#modal-new-user .btn-close').trigger('click');
                    table.ajax.reload();
                    Swal.fire({
                        title: 'Operazione riuscita',
                        text: 'Hai creato con successo l\'account per l\'utente ' + $('#utente-mydonor').val(),
                        icon: 'success',
                    });
                } else {
                    Swal.fire({
                        title: 'Si è verificato un problema',
                        text: 'Non è stato possibile completare la creazione dell\'account per l\'utente ' + $('#utente-mydonor').val(),
                        icon: 'error',
                    });
                }
                showFormFields();
            },
            error: function(error){
                showFormFields();
                Swal.fire({
                    title: 'Si è verificato un problema',
                    text: 'Non è stato possibile completare la creazione dell\'account ' + $('#utente-mydonor').val(),
                    icon: 'error',
                });
            },
        });
    });

    $(document).on('click', '.password-container > .icon-container', function(){
        let input = $(this).parent().find('input');
        if (input.attr('type') === 'password') {
            input.attr('type', 'text');
        } else {
            input.attr('type', 'password');
        }
    });
}

function showFormFields()
{
    $('.form-loader').addClass('d-none');
    $('#create-user').removeClass('d-none');
}